import SubscriptionsView from "./view/subscriptions_view";

export default SubscriptionsView;
